import React, { Component } from 'react';
import {
  Alert,
  Button,
  Card,
  CardTitle,
  CardBody,
  Form,
  FormGroup,
  Input
} from 'reactstrap';

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
      formEmail: '',
      formPassword: '',
      pending: false
    }
  }

  handleEmailInput = (e) => {
    this.setState({
      formEmail: e.target.value,
      errorMessage: ''
    });
  }

  handlePasswordInput = (e) => {
    this.setState({
      formPassword: e.target.value,
      errorMessage: ''
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      errorMessage: '',
      pending: true
    });

    this.props.onLoginAttempt(
      this.state.formEmail,
      this.state.formPassword
    ).catch(e => {
      this.setState({
        errorMessage: e.message || 'Login failed',
        pending: false
      });
    });

  }

  render() {

    return (
        <div className="LoginPage full-page d-flex justify-content-center align-items-center flex-column">

          {
            this.props.message && !this.state.errorMessage &&
            <Alert color={this.props.messageType || 'info'}>
              {this.props.message}
            </Alert>
          }

          {
            this.state.errorMessage &&
            <Alert color="danger">
              {this.state.errorMessage}
            </Alert>
          }

          <Card>
            <CardBody>
              <CardTitle className="text-center">Login</CardTitle>
              <Form>
                <FormGroup>
                  <Input
                    type="email"
                    placeholder="Email"
                    invalid={this.state.errorMessage.toLowerCase().includes('email')}
                    value={this.state.formEmail}
                    onChange={this.handleEmailInput}
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    type="password"
                    placeholder="Password"
                    invalid={this.state.errorMessage.toLowerCase().includes('password')}
                    value={this.state.formPassword}
                    onChange={this.handlePasswordInput}
                  />
                </FormGroup>
                <div className="d-flex mt-4 justify-content-center">
                  <Button
                    color="primary"
                    type="submit"
                    disabled={this.state.pending}
                    onClick={this.handleSubmit}
                  >
                    Log In
                  </Button>
                </div>
              </Form>

              <div className="mt-4 text-center">
                <div>
                  <button
                    className="btn btn-link btn-sm"
                    onClick={this.props.onShowResetPasswordPage}
                  >
                      Forgot your password?
                  </button>
                </div>

                <div>
                  <button
                    className="btn btn-link btn-sm"
                    onClick={this.props.onShowCreateAccountPage}
                  >
                      Need to create an account?
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.jsx